import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const InfoIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

const InfoModal = ({ title, sections = [] }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <>
      <button
        type="button"
        className="analytics-info-btn"
        onClick={toggle}
        title={title}
      >
        <InfoIcon />
      </button>

      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="analytics-info-modal"
        centered
      >
        <ModalHeader toggle={toggle} className="analytics-info-modal-header">
          {title}
        </ModalHeader>
        <ModalBody className="analytics-info-modal-body">
          {sections.map((section, idx) => (
            <div key={idx} className="analytics-info-section">
              <h6 className="analytics-info-section-heading">
                {section.heading}
              </h6>
              <ul className="analytics-info-section-list">
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </ModalBody>
      </Modal>
    </>
  );
};

export default InfoModal;
